const HISTORY_NAVIGATION_TIMEOUT_MS = 2000;

export default async function waitForPopstate(): Promise<void> {
  return new Promise<void>((resolve) => {
    const timeout = setTimeout(resolve, HISTORY_NAVIGATION_TIMEOUT_MS);

    window.addEventListener(
      'popstate',
      () => {
        clearTimeout(timeout);
        resolve();
      },
      {once: true},
    );
  });
}
